import { render, staticRenderFns } from "./Occupancy.vue?vue&type=template&id=128c07d5"
import script from "./Occupancy.vue?vue&type=script&lang=js"
export * from "./Occupancy.vue?vue&type=script&lang=js"
import style0 from "./Occupancy.vue?vue&type=style&index=0&id=128c07d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports